import React, { useEffect, useState } from 'react'
import {Box, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr} from '@chakra-ui/react'
import moment from 'moment';
import Pagination from '../../../../elements/Pagination';
import { connect, useSelector } from 'react-redux';
import Loader from '../../../../elements/loader';
import { bindActionCreators } from 'redux';
import { ActionCreators } from '../../../../../redux/actions';
import NoData from '../../../../elements/NoData';

const PendingInvestors = (props) => {

    const adminState = useSelector((state) => state.adminState)
    const [currentPage, setCurrentPage] = useState(0)
    const [filterData, setFilterData] = useState([])
    const pendingInvestors = adminState?.getNewAccount?.data?.data
    const PER_PAGE = 15;
    const offset = currentPage * PER_PAGE;
    const pageCount = Math.ceil(filterData?.length / PER_PAGE);

    useEffect(() => {
        if (props.tabSelected === 'Pending Investors') {
            let data = {
                status: 'pending',
                usertype: 3,
            }
            props?.actions?.getNewAccountAction(data)
        }
    }, [props.tabSelected])

    useEffect(() => {
        if (adminState?.getNewAccount?.data?.success === true) {
          setFilterData(pendingInvestors)
        }
    }, [adminState?.getNewAccount])

    const handleSearch = (e) => {
        const {value} = e.target
        if (value !== '') {
          const result = pendingInvestors.filter((item) => {
            return item?.mobile?.toLowerCase().includes(value.toLowerCase()) || item?.first_name?.toLowerCase().includes(value.toLowerCase())
          })
          setFilterData(result)
        } else {
          setFilterData(pendingInvestors)
        }
    }
  
    const handlePageClick = ({ selected: selectedPage }) => {
      setCurrentPage(selectedPage);
    }

  return (
    <>
        {(adminState?.getNewAccount?.loading) &&
            <div>
                <Loader />
            </div>
        }
        <Box mt={1}>
            <Box className='search_box'>
                <Input type="text" size="md" name="search" placeholder="Search" onChange={handleSearch}
                    className="input_box font-poppins"
                />
            </Box>
            <>
                {filterData?.length > 0 ?
                    <Box mt={2} className='custom_table_wrapper'>
                        <TableContainer>
                            <Table variant="simple">
                                <Thead>
                                    <Tr>
                                        <Th>S.No.</Th>
                                        <Th>Name</Th>
                                        <Th>Escrow Id</Th>
                                        <Th>Registration Date</Th>
                                        <Th>Phone Number</Th>
                                        <Th>Email Id</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {filterData?.slice(offset, offset + PER_PAGE)?.map((item, index) => {
                                        const serialNumber = offset + index + 1;
                                        return (
                                            <Tr key={index}>
                                                <Td>
                                                    <Text className="font-poppins table_text">{serialNumber}</Text>
                                                </Td>
                                                <Td>
                                                    <Text className="font-poppins table_text">{item?.first_name}{' '}{item?.last_name}</Text>
                                                </Td>
                                                <Td>
                                                    <Text className="font-poppins table_text">{item?.escrow_account_id ? item?.escrow_account_id : 'Not Assigned'}</Text>
                                                </Td>
                                                <Td>
                                                    <Text className="font-poppins table_text">{item?.created_at ? moment(item?.created_at).format('DD-MMM-YYYY'): 'Not Available'}</Text>
                                                </Td>
                                                <Td>
                                                    <Text className="font-poppins table_text">{item?.mobile}</Text>
                                                </Td>
                                                <Td>
                                                    <Text className="font-poppins table_text">{item?.email}</Text>
                                                </Td>
                                            </Tr>
                                        )
                                    })}
                                </Tbody>
                            </Table>
                        </TableContainer>
                        <Pagination pageCount={pageCount} handlePageClick={handlePageClick} />
                    </Box> :
                    <NoData title="No Record Found" />
                }
            </>
        </Box>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ActionCreators, dispatch),
  })
  
export default connect(null, mapDispatchToProps)(PendingInvestors)